import { compose } from 'redux'
import { connect } from 'react-redux'
import { withHandlers } from 'recompose'
import { firebaseConnect } from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import styles from './TaskTimer.styles'
import { timerStop } from 'utils/timer'
import { STAGE_TASK_CHOICE } from 'constants'

const stopDumoTimer = props => () => {
  const { firebase } = props

  timerStop()
  firebase.updateProfile({
    stage: STAGE_TASK_CHOICE,
    lastSeen: Date.now(),
  })
}

export default compose(
  firebaseConnect(props => [`users/${props.uid || ''}`]),
  connect(state => {
    const { interactions, firebase } = state
    const { profile } = firebase

    return {
      dumoDesc: profile.dumoDesc || '',
      countdownValue: interactions.countdownValue,
      uid: profile.uid || '',
    }
  }),
  withHandlers({
    stopDumoTimer,
  }),
  withStyles(styles)
)



// WEBPACK FOOTER //
// ./src/components/TaskTimer/TaskTimer.enhancer.js